import { render, staticRenderFns } from "./secondClaimDialogHN.vue?vue&type=template&id=226d807e&scoped=true"
import script from "./secondClaimDialogHN.vue?vue&type=script&lang=js"
export * from "./secondClaimDialogHN.vue?vue&type=script&lang=js"
import style0 from "./secondClaimDialogHN.vue?vue&type=style&index=0&id=226d807e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226d807e",
  null
  
)

export default component.exports